module.exports = __webpack_public_path__ + "images/style-7-f2ab322c458a25b49de7b4d335381166.jpg";